import { TimeService_timeServiceGetGetTime } from '@festina/life-general-types/life-test/hooks/TimeService_timeServiceGetGetTime'

export const useFetchLifeTime =
  TimeService_timeServiceGetGetTime.useSuspenseQuery
